import { formatYearFieldValue } from '@Utils';
import {
	getAssetManhole,
	getAssetManholeRejected,
	getAssetManholeResolved,
} from '@Actions/assetManhole.actions';
import { put, retry, takeLatest } from 'redux-saga/effects';

import { AnyAction } from 'redux';
import { AssetManholeSummaryResolvedResponse } from '@Types/asset.types';
import { AxiosResponse } from 'axios';
import { getSummaryApi } from '@Services';

// TODO make it generic @AssetSchemaMigration
function* getAssetManholeSaga(action: AnyAction) {
	try {
		const payload: AxiosResponse<AssetManholeSummaryResolvedResponse> =
			yield retry(5, 15000, getSummaryApi, action.payload);

		if (payload.data?.asset) {
			// Hardcoded on purpose - unlike isYearField in the Properties panel,
			// this list won't auto-cover a new year* field added to the schema.
			if (payload.data.asset['yearLaid']) {
				payload.data.asset['yearLaid'] =
					formatYearFieldValue(payload.data.asset['yearLaid']) ?? '';
			}

			if (payload.data.asset['yearInstalled']) {
				payload.data.asset['yearInstalled'] =
					formatYearFieldValue(payload.data.asset['yearInstalled']) ??
					'';
			}

			if (payload.data.asset['yearRenewed']) {
				payload.data.asset['yearRenewed'] =
					formatYearFieldValue(payload.data.asset['yearRenewed']) ?? '';
			}
		}

		yield put(getAssetManholeResolved(payload.data));
	} catch (_e) {
		yield put(getAssetManholeRejected());
	}
}

function* watchGetAssetManhole() {
	yield takeLatest(getAssetManhole, getAssetManholeSaga);
}

export default [watchGetAssetManhole()];
